// Import SSR polyfills FIRST before anything else
import "./lib/ssr-polyfills";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Complete SSR guard - only execute client-side code when window is available
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const rootElement = document.getElementById("root");
  
  if (rootElement) {
    // Use createRoot for all cases to avoid hydration issues
    createRoot(rootElement).render(
      <HelmetProvider>
        <App />
      </HelmetProvider>
    );
  } else {
    console.error("Root element not found");
  }
}
